// AnyAction kept for AppThunk 4th param: DynamicStoreManager drops ThunkDispatch generics, so
// using UnknownAction here causes dispatch(thunk) call-sites to fail. Task 3.6 completed for
// the ToolkitStore → EnhancedStore migration; AnyAction deprecation tracked for later.
// eslint-disable-next-line @typescript-eslint/no-deprecated
import { AnyAction, UnknownAction, configureStore, ThunkAction, ThunkDispatch } from '@reduxjs/toolkit';
import { reducers } from 'app/store/reducers';
import { apiMiddlewares } from 'app/store/reducers/api';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { DynamicStoreManager } from './dynamicStoreManager';
import { errorMiddleware } from './middleware/errorMiddleware';

const initialStore = configureStore({
  reducer: { ...reducers },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(...apiMiddlewares, errorMiddleware),
  // TODO add createLogger
  devTools: process.env.NODE_ENV !== 'production',
});

export const dynamicStoreManager = new DynamicStoreManager(initialStore);

const getStore = () => dynamicStoreManager.store;

export type IRootState = ReturnType<typeof dynamicStoreManager.store.getState>;
export type AppDispatch = ThunkDispatch<IRootState, unknown, AnyAction>;
export const useAppSelector: TypedUseSelectorHook<IRootState> = useSelector;
export const useAppDispatch = () => useDispatch<AppDispatch>();
// eslint-disable-next-line @typescript-eslint/no-deprecated
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, IRootState, unknown, AnyAction>;

export default getStore;
